import { apiSlice } from '../../api/slice'

export const missionControlApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProjectById: builder.query({
      query: ({ projectId }) => ({
        url: `/project/b2c/id/${projectId}`,
      }),
    }),
    getProjectBySlug: builder.query({
      query: ({ slug }) => ({
        url: `/project/b2c/${slug}`,
      }),
    }),
    getProjectXp: builder.query({
      query: ({ projectId }) => ({
        url: `/xp/${projectId}`,
      }),
    }),
    getProjectLeaderboard: builder.query({
      query: ({ projectId, limit, offset }) => ({
        url: `/project/${projectId}/leaderboard`,
        params: {
          limit,
          offset,
        },
      }),
    }),
    getProjectUserSlicedLeaderboard: builder.query({
      query: ({ projectId }) => ({
        url: `/project/${projectId}/leaderboard/sliced`,
      }),
    }),
    generateProjectReferral: builder.mutation({
      query: ({ projectId, taskId }) => ({
        url: `/project/${projectId}/${taskId}/generate-referral`,
        method: 'POST',
      }),
    }),
    getProjectByReferralCode: builder.query({
      query: ({ code }) => ({
        url: `/project/referral/${code}`,
        method: 'GET',
      }),
    }),
  }),
})

export const {
  useGetProjectByIdQuery,
  useLazyGetProjectByIdQuery,
  useGetProjectBySlugQuery,
  useLazyGetProjectBySlugQuery,
  useLazyGetProjectXpQuery,
  useGetProjectXpQuery,
  useGetProjectLeaderboardQuery,
  useLazyGetProjectLeaderboardQuery,
  useGetProjectUserSlicedLeaderboardQuery,
  useLazyGetProjectUserSlicedLeaderboardQuery,
  useGenerateProjectReferralMutation,
  useGetProjectByReferralCodeQuery,
  useLazyGetProjectByReferralCodeQuery,
} = missionControlApiSlice
